module.exports = __webpack_public_path__ + "img/4.033273c2.png";